module.exports = __webpack_public_path__ + "img/logo-icon-app.6ad37ae0.png";